import Annualgeneralmeeting_background from "../images/Annualgeneralmeeting/Annualgeneralmeeting_background.png";
import Annualgeneralmeeting1 from "../images/Annualgeneralmeeting/Annualgeneralmeeting1.png";
import Annualgeneralmeeting2 from "../images/Annualgeneralmeeting/Annualgeneralmeeting2.png";

export const Annualgeneralmeetingslides = [

/* ---------------- 🏢 SLIDE 1 — AGM INTRO ---------------- */
[
  {
    id: 1,
    type: "background",
    src: Annualgeneralmeeting_background,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  {
    id: 25,
    type: "image",
    src: Annualgeneralmeeting1,
    x: 260,
    y: 300,
    width: 300,
    height: 400
  },

  {
    id: 2,
    type: "text",
    text: "🏢 Annual General Meeting 2026 🏢",
    x: 65,
    y: 140,
    fontSize: 26,
    fontFamily: "Poppins",
    fill: "#f6f6f8",
  },

  

  {
    id: 4,
    type: "text",
    text: "Empowering Growth, Leadership & Vision",
    x: 140,
    y: 200,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#f6f6f8"
  },

  {
    id: 5,
    type: "text",
    text: "Join us for an important gathering of shareholders",
    x: 100,
    y: 250,
    fontSize: 14,
    fontFamily: "Poppins",
    fill: "#f6f6f8"
  },

  {
    id: 6,
    type: "text",
    text: "📊 Annual Reports",
    x: 50,
    y: 400,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#f6f6f8"
  },

  {
    id: 17,
    type: "text",
    text: "📈 Business Growth",
    x: 45,
    y: 450,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#f6f6f8"
  },

  {
    id: 18,
    type: "text",
    text: "🤝 Leadership Discussions",
    x: 20,
    y: 500,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#f6f6f8"
  },

  {
    id: 7,
    type: "text",
    text: "💼 Strategic Planning",
    x: 35,
    y: 550,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#f6f6f8"
  },

  {
    id: 19,
    type: "text",
    text: "🎯 Future Goals",
    x: 70,
    y: 600,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#f6f6f8"
  }
],


/* ---------------- 🏢 SLIDE 2 — AGM DETAILS ---------------- */
[
  {
    id: 8,
    type: "background",
    src: Annualgeneralmeeting_background,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  {
    id: 26,
    type: "image",
    src: Annualgeneralmeeting2,
    x: 35,
    y: 300,
    width: 300,
    height: 400
  },

  {
    id: 10,
    type: "text",
    text: "📌 You're Invited 📌",
    x: 170,
    y: 90,
    fontSize: 28,
    fontFamily: "Open Sans",
    fill: "#f6f6f8"
  },

  {
    id: 11,
    type: "text",
    text: "📅 20 March 2026",
    x: 200,
    y: 150,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#f6f6f8"
  },

  {
    id: 12,
    type: "text",
    text: "⏰ 10:00 AM",
    x: 210,
    y: 200,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#f6f6f8"
  },

  {
    id: 13,
    type: "text",
    text: "📍 Corporate Hall, Vijayawada",
    x: 130,
    y: 250,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#f6f6f8"
  },

  {
    id: 14,
    type: "text",
    text: "Together Towards Success",
    x: 350,
    y: 400,
    fontSize: 17,
    fontFamily: "Open Sans",
    fill: "#f6f6f8"
  },

  {
    id: 15,
    type: "text",
    text: "Your Presence Matters,",
    x: 350,
    y: 450,
    fontSize: 17,
    fontFamily: "Poppins",
    fill: "#f6f6f8"
  },

  {
    id: 20,
    type: "text",
    text: "Let's Shape the Future",
    x: 340,
    y: 500,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#f6f6f8"
  },

  {
    id: 16,
    type: "text",
    text: "🏢 AGM 2026 🏢",
    x: 340,
    y: 580,
    fontSize: 28,
    fontFamily: "Dancing Script",
    fill: "#f6f6f8"
  }
]

];